import React, { Component , createRef} from "react";
// import * as ReactDOM from "react-dom";

import { DatePicker } from "@progress/kendo-react-dateinputs";
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';

import enMessages from './../custom_modules/translations/en/en.json';
import koMessages from './../custom_modules/translations/ko/ko.json';
import frMessages from './../custom_modules/translations/fr/fr.json';
import grMessages from './../custom_modules/translations/de/de.json';
loadMessages(enMessages, "en-En");
loadMessages(koMessages, "ko-KO");
loadMessages(frMessages, "fr-FR");
loadMessages(grMessages, "de-DE");

class KendoDatepicker extends Component {
    constructor(props) {
        super(props);
        this.datepickerRef = createRef(); 
        this.state = {
            value: this.parseDefaultValue(this.props.DefaultValue),
            MaxiDate: this.props.maxdate !== undefined ? this.props.maxdate : new Date(),
            miniDate: this.props.mindate !== undefined ? this.props.mindate : undefined
        };

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value:
                nextProps.DefaultValue !== undefined
                    ? new Date(nextProps.DefaultValue)
                    : null,
            MaxiDate: nextProps.maxdate !== undefined ? nextProps.maxdate : new Date(),
            miniDate: nextProps.mindate !== undefined ? nextProps.mindate : undefined
        });
    }

    parseDefaultValue(defaultValue) {
        if (!defaultValue || defaultValue === "") {
            return null;
        }
        if (defaultValue instanceof Date) {
            return defaultValue;
        }
        const parsedDate = new Date(defaultValue);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

   handleChange = event => {
        this.setState({
            value: event.target.value
        });

        this.props.onDatachanges(event.target.value);
    };

    getformat(format) {
        console.log(format);
        switch (format) {
            case "MM/DD/YY HH:mm:ss":
                return "MM/dd/yyyy";
            case "Mon-DD-YYYY HH:mm:ss":
                return "MMM-dd-yyyy";
            case "YY/MM/DD HH:mm:ss":
                return "yyyy/MM/dd";
            case "dd-MM-yy HH:mm:ss":
                return "dd-MM-yy";
            case "dd-MM-yyyy HH:mm:ss":
                return "dd-MM-yyyy";
            case "UTC Format":
                return "dd MMM yyyy"
            default:
                return "dd/MM/yyyy";
        }
    }

    disableManualInput = () => {
        if (this.datepickerRef?.current) {
            const input = this.datepickerRef.current.element.querySelector("input");
            if (input) {
                // prevent typing
                input.addEventListener("keydown", (e) => {
                    if (this.props.allowTyping === false) e.preventDefault();
                });

                // prevent pasting
                input.addEventListener("paste", (e) => {
                    if (this.props.allowTyping === false) e.preventDefault();
                });

                // disable mouse wheel
                input.addEventListener("wheel", (e) => e.preventDefault());
            }
        }
    };

    render() {
        let lang = localStorage.getItem("ElnLang");
        let localizeprovider = "en-EN";
        if (lang !== null) {
            localizeprovider = lang + "-" + lang.toUpperCase();
        }

        return (
            <LocalizationProvider language={localizeprovider}>
                
                <DatePicker
                        ref={this.datepickerRef}
                        value={this.state.value}
                        onChange={this.handleChange}
                        max={this.state.MaxiDate}
                        min={this.state.miniDate}
                        disabled={this.props.disabled}
                        editable={false}          // prevent editing
                        onKeyDown={this.handleKeyDown}               // prevent typing
                        onPaste={this.handlePaste}                   // preve
                        wheel={false}             // block wheel scroll
                        className="clskendoDatepick"
                        popupSettings={{
                            animate: true,
                            popupClass: `clsKendoDatepop ${this.props.class}`
                        }}
                        onFocus={this.disableManualInput}
                    />
            </LocalizationProvider>
        );
    }
}
export default KendoDatepicker;
